import { mergeBuilder } from "@dirootie-extensions/javascript";
import { IColumnProps } from "taltech-styleguide";
import { ColumnBuilder } from "./_types";
import { columnDefaultProps } from "./_shared";
import { T, assocPath, cond, has, identity, keys, map, objOf, indexBy, prop, mergeAll, sortBy, propOr, pickBy } from 'ramda';
import { isString } from 'ramda-adjunct';
import { findFirstValueDefined, hasAnyProp } from "../../../packages/core/toolbox/objects";
import { cols } from './_columns';
import { safeMerge } from "../../_utils";

export const createColumnProps = (
  systemDefaultProps: Partial<IColumnProps>,
  singleDefaultProps: Partial<IColumnProps> | Partial<IColumnProps>[]
) => {
  const result = mergeBuilder<IColumnProps>(systemDefaultProps, true)
    .merge(singleDefaultProps)
    .build();
  return result;
};

export const columBuilder: ColumnBuilder = (
  props,
  defaults = columnDefaultProps
) => {
  return createColumnProps(defaults, props) as IColumnProps;
};

export const createBuilder: (
  props: Partial<IColumnProps>,
  order: number
) => (props?: Partial<IColumnProps>) => IColumnProps = (col,order) => {
  return (props?: Partial<IColumnProps>) => {
    const defaults = {...createColumnProps(columnDefaultProps, col), order};
    if (props === undefined) {
      return defaults as IColumnProps;
    } else {
      return createColumnProps(defaults, props) as IColumnProps;
    }
  };
};

export const normalizeId = <T extends {id?: string}> ( propNames:string[],obj: any): Partial<T> => {

  const result = cond([
    [has("id"), identity],
    [isString, (x:any) => (objOf as any)("id")(x)],
    [hasAnyProp(propNames), assocPath(["id"],[findFirstValueDefined(propNames,obj,"not_set")])],
    [T,identity]
  ])(obj);
  return result;
}

export const normalizeIds = (objects: any[], propNames:string[] = ["dataField","key"]) => map(x => normalizeId(propNames,x),objects);

export const getDefaultsAndOverrides = <T = any>(defaults:Record<string,T>) => (objects: Record<string,T>[]) => (keys:  string[]) => {
  const objs = [defaults,...objects];
  const results = map(x => map(y => propOr(prop("custom",y),x)(y as any),objs),keys);
  return map(mergeAll,results);
}

export const processColumns = <T>(columns:(string | Partial<IColumnProps>)[] = [], entity?:T) => {
  const colsFromEntityKeys = indexBy((x:any) => x["id"])(normalizeIds(entity ? keys(entity) : []));
  const colsFromColumns = indexBy((x:any) => x["id"])(normalizeIds(columns ? columns : []));
  const colsToUse1 = safeMerge(colsFromColumns,colsFromEntityKeys);
  const keysToUse = keys(colsToUse1);
  const colsToUse = safeMerge(pickBy((v:any,k:string) => has(k,colsToUse1),cols),colsToUse1);
  const re = getDefaultsAndOverrides(cols)([colsToUse])(keysToUse as any);

  const colsFinal = sortBy(propOr(1000,"order") as any,re);
  return colsFinal;
}
